import {post, get} from '@/utils/apiBase.js'
// 获取解锁目标赠送方式 
const getGoalGiveaway = option => {
    return get('/apis/project/cp/cp_goal/get_goal_giveaway', option)
}
// 获取解锁项列表
const getNnlockGoalList = option => {
    return get('/apis/project/cp/cp_goal/get_unlock_goal_list', option)
}
// 创建解锁目标赠送方式
const saveGoalGiveaway = option => {
    return post('/apis/project/cp/cp_goal/save_goal_giveaway', option)
}
// 获取解锁目标商品
const getGoalPrizeList = option => {
    return get('/apis/project/cp/cp_goal/get_goal_prize_list', option)
}
// 创建商品
const createGoalPrize = option => {
    return post('/apis/project/cp/cp_goal/create_goal_prize', option)
}
// 编辑商品
const editGoalPrize = option => {
    return post('/apis/project/cp/cp_goal/edit_goal_prize', option)
}
// 创建解锁项
const createGoal = option => {
    return post('/apis/project/cp/cp_goal/create_goal', option)
}
// 编辑解锁项
const editGoal = option => {
    return post('/apis/project/cp/cp_goal/edit_goal', option)
}
// 删除解锁项 
const delGoal = option => {
    return post('/apis/project/cp/cp_goal/del_goal', option)
}
// 发布解锁项
const releaseGoal = option => {
    return post('/apis/project/cp/cp_goal/release_goal', option)
}
// 赠品单详情
const getGiftOrderDetail = option => {
    return get('/apis/mdcporder/order/gift_order_detail', option)
}
// 获取赠品档订单生成状态
const getProUnlockGiftOrderStatus = option => {
    return get('/apis/mdcporder/order/get_pro_unlock_gift_order_status', option)
}
export default {
    getGoalGiveaway,
    getNnlockGoalList,
    saveGoalGiveaway,
    getGoalPrizeList,
    createGoalPrize,
    editGoalPrize,
    createGoal,
    editGoal,
    delGoal,
    releaseGoal,
    getGiftOrderDetail,
    getProUnlockGiftOrderStatus
};